import React from 'react';

import { Text } from '@zapier/design-system';

import VersionModalWrapper from './VersionModalWrapper';

import type { SemVer } from 'app/developer-v3/types/version';

type Props = {
  isSaving: boolean;
  onClose: () => void;
  onConfirm: () => void;
  version: SemVer;
};

const Legacy = (props: Props) => {
  return (
    <VersionModalWrapper
      confirmButtonLabel="Set as Legacy"
      heading={`Set Version ${props.version} as Legacy`}
      isSaving={props.isSaving}
      onClose={props.onClose}
      onConfirm={props.onConfirm}
    >
      <Text margin="10px 0px" tag="p">
        Legacy versions indicate that they are no longer recommended for use,
        but will continue to function. Unlike deprecation, users are not
        required to migrate before a specific date. Only set a version as legacy
        when they are still functional but no longer receiving updates or
        support.
      </Text>
      <Text margin="10px 0px" tag="p">
        Users will see that this version is legacy, but their automations will
        continue to run without interruption by Zapier. An example use case is
        for versions that are expected to continue working, but are no longer
        actively maintained.
      </Text>
    </VersionModalWrapper>
  );
};

export default Legacy;
